module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Acknowledgments"
    }
  }, [_c('p', {
    staticClass: "FMO"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/00a_fm0e#ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("UCH LIKE MY PRIOR WORK")]), _vm._v(", "), _c('i', [_vm._v("Motor City Movie Culture, 1916–1925")]), _vm._v(" is once again greatly indebted to a network of archives, libraries, colleagues, and friends for sustained support and encouragement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Crucial support for the research on which this book relies came from the facilities and staff of the University of Michigan Hatcher Graduate Library, University of Michigan LSA Information Technology, Detroit Public Library, University of Michigan Bentley Historical Library, and University of Texas-Austin Ransom Center. That research also benefited from online databases of the Wayne State University Library, the "), _c('i', [_vm._v("Detroit Free Press")]), _vm._v(", the Media History Digital Library, "), _c('a', {
    attrs: {
      "href": "http://geneologybank.com",
      "target": "_blank"
    }
  }, [_vm._v("geneologybank.com")]), _vm._v(", and "), _c('a', {
    attrs: {
      "href": "http://newspapers.com",
      "target": "_blank"
    }
  }, [_vm._v("newspapers.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I especially was grateful for the anonymous readers’ reports that offered timely suggestions for revising the final version of the book. In different ways, each was helpful in making the introduction more precise in explaining the book’s subject, what it is and is not primarily as a cultural history. Their suggestions also prodded me to reorganize and reduce the last chapter on Detroit’s newspaper discourse, urged me to reposition the extensive list of picture theaters from an appendix to an early Entr’Acte, and confirmed my stress on certain lines of inquiry for further research in the afterword.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Special thanks go to Michael Hauser for permission to photocopy his personal collection of the "), _c('i', [_vm._v("Weekly Film News")]), _vm._v(" and to current and former University of Michigan doctoral students for their generous assistance. Ben Strassfeld found rare archive materials such as the "), _c('i', [_vm._v("Michigan Film Review")]), _vm._v(" as well as the digitized files of the "), _c('i', [_vm._v("Detroit News Pictorial")]), _vm._v(", codesigned a graduate seminar that I taught on the history of Detroit, and created original maps of Detroit neighborhoods and many picture theater locations. Caitlin Dickinson deftly revised those into vector maps as required by the press. Ken Garner constructed a database of Detroit picture theaters, and Katy Peplin allowed me to draw on her research into Ford materials at the Ford Historical Museum and the National Archive. At one time or another, Garner, Strassfeld, Nathan Koob, and Jim Carter all scanned years of pages from the microfilm of surviving Detroit newspapers and offered useful contextual suggestions. Ginny Agnew photographed several fragments of early “house organ” programs that Koob found in research at the Ransom Center.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many colleagues and friends graciously shared their own sources, helped locate new resources, posed pertinent questions, and led me to pursue those questions in unexpected ways. Paul S. Moore was especially helpful for his extensive "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_vm._v("knowledge of the early twentieth-century history of newspapers, film distribution, and film exhibition. Other support of one kind or another came from, in alphabetical order, Matthew Bernstein, Giorgio Bertellini, John Bukowczyk, Mark Garrett Cooper, Don Crafton, Leslie Midkiff DeBauche, Kathryn Fuller-Seeley, Doron Galili, Dan Herbert, Martin L. Johnson, Richard Koszarski, Stéphanie Salmon, Gregory Waller, and Mark Williams.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At Indiana University Press, Raina Polivka first expressed strong interest in the project. When she became acquisitions editor, Janice Frisch persuaded me to sign a contract with the press, and she smoothly kept the project on track, particularly when delays occurred in the later stages of writing. Allison Chaplin expertly eased the manuscript into production, despite some initial confusion over a few illustrations. David Hulsey directed the design team for the book’s cover, and David Miller oversaw the processes of copyediting and proof review, which were handled so meticulously and efficiently by Jennifer Crane, Editorial Project Manager at Amnet. Garner helped edit the final version of the index.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, finally, I am so deeply grateful to Barbara for the forty-two years we had together, often as Eeyore and Pooh, engaging in one “Expotition” after another “to discover what? . . . Oh, just something.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn1",
      "id": "ch00fn1"
    }
  }, [_vm._v("1")])]), _vm._v(" I would not have missed any of those for the world. Despite a lengthy illness, Barbara wrote another groundbreaking book, "), _c('i', [_vm._v("Shakespeare, Performance and the Archive")]), _vm._v(" (2016) and several essays, the last of which, “The Shakespeare Phonograph,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch00rfn2",
      "id": "ch00fn2"
    }
  }, [_vm._v("2")])]), _vm._v(" announced a new research direction that has been cut short. Her keen intelligence, marvelously cadenced prose style, and mischievous wit certainly elevated my own writing. One of her typical marginal comments in reading most of the manuscript was “Punch up that last sentence.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But words sometimes do fail, now that “a great spirit is gone.”")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Parts of two chapters either draw on or are revised and much expanded versions of the following published essays:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "BL-First"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("“‘House Organs’ and the Detroit "), _c('i', [_vm._v("Weekly Film News")]), _vm._v(" in the Late 1910s.” "), _c('i', [_vm._v("Film History")]), _vm._v(" 27, no. 3 (2015): 137–179.")])]), _vm._v(" "), _c('p', {
    staticClass: "BL-Last"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("“The Circulation of Local Newsreels in the Silent Period: The Case of Detroit.” In "), _c('i', [_vm._v("Rediscovering U.S. Newsfilm: Cinema, Television, and the Archive")]), _vm._v(", edited by Mark Garrett Cooper, Sarah Beth Levavy, Ross Melnick, and Mark Williams, 133–154. New York: Routledge, 2018.")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch00rfn1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn1"
    }
  }, [_vm._v("1")]), _vm._v(". A. A. Milne, "), _c('i', [_vm._v("Winnie the Pooh")]), _vm._v(" (New York: E. P. Dutton, 1926), 112.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "ch00rfn2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch00fn2"
    }
  }, [_vm._v("2")]), _vm._v(". Barbara Hodgdon, “The Shakespeare Phonograph,” "), _c('i', [_vm._v("Shakespeare Bulletin")]), _vm._v(" 35, no.1 (Spring 2017): 1–14, doi:10.1353/shb.2017.0000.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5be072d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/00a_fm0f.vue
// module id = 75
// module chunks = 0